import _t from 'i18n!nls/custom-labels';

export const capitalizeEachWord = (str: string | undefined): string | undefined => {
  if (!str) {
    return undefined;
  }

  return str.replace(/\w\S*/g, (word) => word.replace(/^\w/, (char) => char.toUpperCase()));
};

export const getCustomCourseTerm = (courseraCourse?: string | null, capitalize?: boolean): string | undefined => {
  let customTerm;
  if (!courseraCourse) {
    customTerm = _t('course');
  } else if (courseraCourse === 'guided project' || courseraCourse === 'project') {
    customTerm = _t('project');
  } else {
    customTerm = courseraCourse;
  }

  return capitalize ? capitalizeEachWord(customTerm) : customTerm;
};

export const getCustomWeekTerm = (
  isModuleDefault: boolean,
  courseraWeek?: string,
  capitalize?: boolean
): string | undefined => {
  let customTerm;
  if (!courseraWeek && isModuleDefault) {
    customTerm = _t('module');
  } else if ((!courseraWeek && !isModuleDefault) || courseraWeek?.toLowerCase() === 'week') {
    customTerm = _t('week');
  } else if (courseraWeek === 'project') {
    customTerm = _t('project');
  } else if (courseraWeek === 'module') {
    customTerm = _t('module');
  } else {
    customTerm = courseraWeek;
  }

  return capitalize ? capitalizeEachWord(customTerm) : customTerm;
};
